<template>
  <div v-if="loaded" class="project-layout">
    <app-header>
      <template #title>
        <stage-selector v-if="project.client" :project="project" :stage="stage"></stage-selector>
      </template>
      <template #actions>
        <save-status v-if="$route.name == 'projects.stage1.userstories'"></save-status>
        <ul v-if="otherMembers.length" class="team-members">
          <li v-for="member in otherMembers" v-bind:key="member.id">
            <img :alt="member.name" v-bind:src="getAvatar(member.id)" />
          </li>
        </ul>
      </template>
    </app-header>

    <div class="layout-sidesheet row">
      <div class="col main-content d-flex flex-column">
        <ul id="horizontal-nav" class="nav nav-horizontal sticky-top" style="position: sticky">
          <router-link @click="reload" tag="li" class="nav-item" :to="{ name: 'projects.stage1.overview' }">
            <a class="nav-link">Overview</a>
          </router-link>
          <router-link
            v-if="stage.user_story_doc_id"
            tag="li"
            class="nav-item"
            :to="{
              name: 'projects.stage1.deliverables',
              params: { user_story_doc_id: stage.user_story_doc_id, sprint_id: 'active' },
            }"
          >
            <a class="nav-link">Deliverables</a>
          </router-link>
          <router-link tag="li" class="nav-item" :to="{ name: 'projects.stage1.userstories' }">
            <a class="nav-link">Userstories</a>
          </router-link>
          <router-link tag="li" class="nav-item" :to="{ name: 'projects.stage1.activity' }">
            <a class="nav-link">Activity</a>
          </router-link>
        </ul>
        <!-- /#horizontal-nav -->

        <component :is="modalComponentForRoute" :project="project"></component>
        <opportunity-drawer v-if="$route.name == 'projects.stage1.overview'" ref="opportunityDrawer"></opportunity-drawer>
        <edit-drawer v-if="$route.name == 'projects.stage1.overview'" ref="editDrawer"></edit-drawer>

        <router-view></router-view>
      </div>

      <div class="col-auto project-right-nav">
        <ul>
          <li v-if="$route.name == 'projects.stage1.overview'">
            <button type="button" class="btn" @click="openDrawer('editDrawer')">
              <i class="far fa-edit"></i>
            </button>
          </li>
          <li v-if="$route.name == 'projects.stage1.overview'">
            <button type="button" class="btn" @click="openDrawer('opportunityDrawer')">
              <i class="far fa-file-edit"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndex, find } from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import EditDrawer from './project/stage/EditDrawer'
import stageSelector from './_stage-selector'
import SaveStatus from '../misc/SaveStatus'
import { OpportunityDrawer } from './project/stage2'
import SettingsModalStage2 from './project/stage2/SettingsModal'
import { ADD_EPIC, ADD_USERSTORY, REMOVE_USERSTORY, SET_USERSTORY_PROPERTY } from 'vx/mutations'
import { echo } from 'mixins'

var project = require('./../../models/project.js')

export default {
  mixins: [echo],

  components: {
    SaveStatus,
    EditDrawer,
    stageSelector,
    OpportunityDrawer,
    SettingsModalStage2,
  },

  data: function () {
    return {
      members: [],
      loaded: false,
      presenceChannelName: '',
      //otherMembers: []
    }
  },

  computed: {
    ...mapState('settings/userstories', ['view_options']),
    ...mapState('yodizproject', {
      project: 'single',
    }),
    ...mapState('yodizproject/stages', {
      stage: 'single',
    }),
    ...mapState('epics', ['epics']),

    missingEstimates() {
      var count = 0

      this.project.user_story_document.epics.forEach(function (epic) {
        count += epic.stories.filter(function (item) {
          return item.estimate == null
        }).length
      })

      return count
    },

    otherMembers() {
      return this.members.filter((item) => {
        return item.id !== this.$user.id
      })
    },

    showSubMenu() {
      return find(this.$route.matched, ['name', 'projects.show.stage2']) != undefined
    },

    subMenuTitle() {
      if (this.$route.name == 'projects.show.stage2.userstories') {
        return 'User Stories'
      } else if (this.$route.name == 'projects.show.stage2.deliverables') {
        return 'Deliverables'
      } else if (this.$route.name == 'projects.show.stage2.schedule') {
        return 'Schedule'
      } else if (this.$route.name == 'projects.show.stage2.quotes') {
        return 'Quotes'
      }

      return ''
    },

    modalComponentForRoute() {
      if (find(this.$route.matched, ['name', 'projects.stage1']) != undefined) {
        return 'settings-modal-stage2'
      }

      return ''
    },
  },
  beforeRouteUpdate(to, from, next) {
    //Refresh stage data if user has navigated back to the overview
    if (to.name == 'projects.stage1.overview') {
      this.getStage(this.$route.params.stage_id)
    }

    next()
  },
  mounted: function () {
    this.getYodizProject(this.$route.params.project_id).then(() => {
      this.getStage(this.$route.params.stage_id).then(() => {
        this.loaded = true
      })
    })
  },
  async created() {
    await this.echoConnect()
  },

  beforeDestroy: function () {
    this.echo.leave(this.presenceChannelName)
    this.echoDisconnect()
  },

  methods: {
    ...mapActions('yodizproject', {
      getYodizProject: 'getSingle',
    }),

    ...mapMutations('epics', [ADD_EPIC, ADD_USERSTORY, REMOVE_USERSTORY, SET_USERSTORY_PROPERTY]),
    ...mapActions('yodizproject/stages', {
      getStage: 'getSingle',
    }),

    async connectChannels () {
      this.presenceChannelName = `channel-${this.$route.params.project_id}`

      this.echo
      .join(this.presenceChannelName)
      .here((users) => {
        this.members = users
      })
      .joining((user) => {
        this.members.push(user)
      })
      .leaving((user) => {
        for (var i = 0; i <= this.members.length - 1; i++) {
          if (this.members[i].id == user.id) {
            this.members.splice(i, 1)
          }
        }
      })
      .listen('Project.newRequirementBroadcast', (data) => {
        if (data.requirement.creator_id != this.$user.id) {
          this.project.user_story_document.requirements.push(data.requirement)
        }
      })
      .listen('Project.newEpicBroadcast', (data) => {
        //Ensure stories array exists on new epic / eager load in api isn't loading
        data.epic.stories = []

        this[ADD_EPIC](data.epic)
      })
      .listen('Project.newUserStoryBroadcast', (data) => {
        if (data.story.creator_id !== this.$user.id) {
          this[ADD_USERSTORY](data.story)
        }
      })
      .listen('Project.updateUserStoryBroadcast', (data) => {
        var epic = findIndex(this.epics, (existing) => existing.id === data.story.epic_id)

        if (epic !== -1) {
          let storyIndex = findIndex(this.epics[epic].stories, (existing) => existing.id === data.story.id)

          if (storyIndex >= 0) {
            let propertyString = `epics.${epic}.stories.${storyIndex}`
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.title`, value: data.story.title })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.description`, value: data.story.description })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.estimate`, value: data.story.estimate })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.complexity`, value: data.story.complexity })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.tech_notes`, value: data.story.tech_notes })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.test_notes`, value: data.story.test_notes })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.group_id`, value: data.story.group_id })
            this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.tags`, value: data.story.tags })
          }
        }
      })
      .listen('Project.deleteUserStoryBroadcast', (data) => {
        this[REMOVE_USERSTORY](data.story)
      })
      .listen('Project.lockUserStoryBroadcast', (data) => {
        var story = this.project.user_story_document.epics
          .find((item) => {
            return item.id == data.story.epic_id
          })
          .stories.find((item) => {
            return item.id == data.story.id
          })
        story.locked_by = data.story.locked_by
        story.locked_at = data.story.locked_at
      })
      .listen('Project.updateRequirementBroadcast', (data) => {
        var requirement = this.project.user_story_document.requirements.find((item) => {
          return item.id == data.requirement.id
        })

        if (requirement) {
          this.project.user_story_document.requirements[
            this.project.user_story_document.requirements.indexOf(requirement)
          ].title = data.requirement.title
          this.project.user_story_document.requirements[
            this.project.user_story_document.requirements.indexOf(requirement)
          ].description = data.requirement.description
        }
      })
      .listen('Project.deleteRequirementBroadcast', (data) => {
        var requirement = this.project.user_story_document.requirements.find((item) => {
          return item.id == data.requirementId
        })

        if (requirement) {
          this.project.user_story_document.requirements.splice(
            this.project.user_story_document.requirements.indexOf(requirement),
            1
          )
        }
      })
      .listen('Project.requirementUserStoryBroadcast', (data) => {
        var requirement = this.project.user_story_document.requirements.find((item) => {
          return item.id == data.requirement.id
        })

        if (requirement) {
          this.project.user_story_document.requirements[
            this.project.user_story_document.requirements.indexOf(requirement)
          ].story_id = data.requirement.story_id
        }
      })
      .listen('Project.lockProjectNotesBroadcast', (data) => {
        this.project.user_story_document.locked_by = data.userStoryDocument.locked_by
        this.$bus.$emit('notesLocked', data.userStoryDocument.locked_by != null)
      })
      .listen('Project.projectNotesUpdatedBroadcast', (data) => {
        this.project.user_story_document.notes = data.userStoryDocument.notes
      })
    },

    getAvatar: function (id) {
      return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar'
    },

    openDrawer(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].open()
      }
    },

    reload() {
      this.loaded = false

      this.getStage(this.$route.params.stage_id).then(() => {
        this.loaded = true
      })
    },
  },
}
</script>
